<template>
  <v-layout column fill-height>
    <v-flex class="header" shrink>
      <navigation fixed />
    </v-flex>
    <v-flex class="main has-fixed-header" :class="{ 'has-cookie': showCookie, 'has-announcement': storeInfo.storeConf && storeInfo.storeConf.isAnnouncement }">
      <router-view />
    </v-flex>
    <v-flex shrink>
      <Footer v-if="showStoreInfoFooter" />
      <copyright v-else />
    </v-flex>
  </v-layout>
</template>

<script>
import store from "@/api/store";
import { mapState } from "vuex";

import Navigation from "../common/navigation";
import Copyright from "../common/copyright";
import Footer from "../common/footer";

export default {
  data() {
    return {
      showStoreInfoFooter: false
    };
  },
  created() {
    if (this.$route.matched[1].props.default) {
      this.showStoreInfoFooter = true;
    } else {
      this.showStoreInfoFooter = false;
    }
    store.getFacebook().then(res => {
      if (!res.data.isError) {
        // eval('res.data.data');
        eval(
          "        !function(f,b,e,v,n,t,s)\n" +
            "        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
            "            n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n" +
            "            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n" +
            "            n.queue=[];t=b.createElement(e);t.async=!0;\n" +
            "            t.src=v;s=b.getElementsByTagName(e)[0];\n" +
            "            s.parentNode.insertBefore(t,s)}(window, document,'script',\n" +
            "            'https://connect.facebook.net/en_US/fbevents.js');\n" +
            "        fbq('init', '141260904476144');\n" +
            "        fbq('track', 'PageView');"
        );
      }
    });
  },
  components: {
    Navigation,
    Copyright,
    Footer
  },
  computed: {
    ...mapState(["showCookie", "storeInfo"])
  },
  watch: {
    $route() {
      console.log(this.$route.matched[1].props.default);
      if (this.$route.matched[1].props.default) {
        this.showStoreInfoFooter = true;
      } else {
        this.showStoreInfoFooter = false;
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./basic-layout.sass"></style>
